var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9151 29.5308L27.0214 29.6367L27.1277 29.5308L29.7114 26.9586L29.8177 26.8528L29.7114 26.7469L17.94 15.0278L29.4603 3.5586L29.5666 3.45277L29.4603 3.34694L26.8208 0.719164L26.7145 0.613334L26.6082 0.719164L15.0879 12.1883L3.31655 0.469176L3.21025 0.363346L3.10394 0.469177L0.520263 3.0414L0.413962 3.14723L0.520263 3.25306L12.2916 14.9722L0.771364 26.4414L0.665062 26.5472L0.771363 26.6531L3.41084 29.2808L3.51715 29.3867L3.62345 29.2808L15.1437 17.8117L26.9151 29.5308Z",
    fill: "#FFBA80",
    stroke: "#FFBA80",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGold);
export default __webpack_public_path__ + "static/media/close-gold.ee4f534b3a832cbde5acdb2727eadcc3.svg";
export { ForwardRef as ReactComponent };